import { BASE_URL } from "@/constants/endpoints";
import { ScheduledTransferDetail } from "@/pages/requests/scheduled-transfer/schema/scheduled-transfer.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let scheduledTransferApiPromise: Promise<AxiosInstance> | null = null;

const getScheduledTransferApi = async () => {
  if (scheduledTransferApiPromise) return scheduledTransferApiPromise;
  scheduledTransferApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return scheduledTransferApiPromise;
};

export interface GetScheduledTransferRequestsProps {
  fecha: string;
  monto: number;
  nroCuenta: string;
  idSucursal: number[];
  estado: string[];
  usuario: string;
  "P.Pagina": number;
  "P.Records": number;
}

export const getScheduledTransferRequests = async (
  props: GetScheduledTransferRequestsProps,
) => {
  const api = await getScheduledTransferApi();
  if (!api) return null;
  const response = await api.get(
    `/TransferenciasProgramadas?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface GetScheduledTransferRequestProps {
  id: number;
  usuarioActual: string;
}

export const getScheduledTransferRequest = async (
  props: GetScheduledTransferRequestProps,
): Promise<ScheduledTransferDetail | null> => {
  const api = await getScheduledTransferApi();
  if (!api) return null;
  const response = await api.get(
    `/TransferenciasProgramadas/Detalle?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CancelScheduledTransferProps {
  id: number;
  idMotivo?: number;
  mensaje?: string;
  usuarioActual?: string;
  esRechazo?: boolean;
}

export const cancelScheduledTransfer = async (
  props: CancelScheduledTransferProps,
) => {
  const api = await getScheduledTransferApi();
  if (!api) return null;
  const response = await api.delete(
    `/TransferenciasProgramadas/CancelarTransferencia?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface SendScheduledTransferProps {
  idSolicitud: number;
  usuarioActual: string;
}

export const sendScheduledTransfer = async (
  props: SendScheduledTransferProps,
) => {
  const api = await getScheduledTransferApi();
  if (!api) return null;
  const response = await api.put(
    `/TransferenciasProgramadas/RealizarTransferencia?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};
